import CONST from './Constant';

const defaultJwtToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyLCJleHAiOjE1MTYyNDI2MjJ9.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c';

const createInitialState = () => ({
    jwtToken: defaultJwtToken,
    decoded: null, // Will be decoded by useEffect in ProcessorSection (client-side only)
    error: null,
    activeTab: 0,
});

const INITIAL_STATE = createInitialState();

const Reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CONST.RESET:
            return createInitialState();
        case CONST.UPDATE_STATE:
            return {
                ...state,
                ...action.payload,
            };
        case CONST.UPDATE_JWT_TOKEN:
            return {
                ...state,
                jwtToken: action.payload,
                decoded: null, // Clear decoded when token changes
                error: null, // Clear error when token changes
            };
        case CONST.UPDATE_DECODED_DATA_SUCCESS:
            return {
                ...state,
                decoded: action.payload,
                error: null,
            };
        case CONST.UPDATE_DECODED_DATA_FAILED:
            return {
                ...state,
                error: action.payload,
                decoded: null,
            };
        case CONST.UPDATE_ACTIVE_TAB:
            return {
                ...state,
                activeTab: action.payload,
            };
        default:
            return state;
    }
};

export default Reducer;

